var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-button"},[_c('a',{staticClass:"message-button__link",attrs:{"href":`https://wa.me/${_vm.phone}`,"target":"_blank"}},[_c('FileIconComponent',{attrs:{"name":"whatsapp"}})],1),(_vm.schedule)?_c('div',{staticClass:"message-button__text"},[_c('span',[_vm._v(" "+_vm._s(_vm.schedule)+" ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }